import imageCompression from 'browser-image-compression';
import { firestorage } from './Firebase';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
const storage = firestorage();

// const storage = firestorage();



export const UploadFiles = async (files: any, productCode: string) => {
    // let progress, url, error;
    console.log('Inside Upload file function');

    const URL: String[] = [];
    if (files) {
        for (let i = 0; i < files.length; i++) {
            
            const fileName = `${productCode}_ID${i + 1}${files[i].name.substring(files[i].name.lastIndexOf('.'))}`;
            const fileType = files[i].type;
            console.log("🚀 ~ fileType:", fileType)
            const options = {
                maxSizeMB: 0.2,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }
            const storageRef = ref(storage, fileName);
            var uploader;
            if (fileType !== 'application/pdf') {
                const compressedFile = await imageCompression(files[i], options);
                uploader = uploadBytesResumable(storageRef, compressedFile);
            }else{
                uploader = uploadBytesResumable(storageRef, files[i]);
            }
            // const { url, signedRequest } = (await axios.post(baseURL, { fileName, fileType })).data
            // axios.put(signedRequest, compressedFile, { headers: { 'Content-Type': fileType } });
            if ((await uploader).state === 'success') {
                URL.push(await getDownloadURL(storageRef));
            }
            // const storageRef = ref(storage, `${productCode}_ID${i + 1}`);
            // const uploader = uploadBytesResumable(storageRef, compressedFile);
            // if ((await uploader).state === 'success') {
            // URL.push(url);
            // uploader.on('state_changed', (snap) => {
            //     let progress = (snap.bytesTransferred / fileSize) * 100;
            //     callback({ progress });
            // }, (err) => {
            //     callback({ err });
            // }, async () => {
            //     const url = await getDownloadURL(storageRef);
            //     callback({ url });
            //     // URLs.push(url);
            // });
            // url = URLs;
        }
    }
    return URL
}
